import React from 'react';
import { responsiveFont, responsivePaddingHorizontal, responsivePaddingVertical, responsiveImageSize } from '../../common/responsive.utils';
import WriteBrowserComponent from './write/write.browser.component';
import useMediaQuery from '@mui/material/useMediaQuery';
import Dialog from "@mui/material/Dialog";
import BackgroundImageWeb from '../../../assets/images/sitter/web/background.png';
import BackgroundImageMobile from '../../../assets/images/sitter/mobile/background.png';
interface Content01BrowserComponentProps {
    open: boolean;
    closeDialog: () => void;
}

const Content01BrowserComponent: React.FC<Content01BrowserComponentProps> = ({ open, closeDialog }) => {
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles();

    return (
        <>
            {isWeb ? (
                <>
                    <div style={{ height: "142px" }} />
                    <div style={styles.screen_Web}>
                        <div style={styles.paddingLeftDiv_Web}>
                            <span style={styles.titleTxt_Web}>
                                우리 동네, 펫시터<br />
                                지금 시작해보세요
                            </span>
                            <div style={{ height: "0.9375vh" }} />
                            <span style={styles.contentTxt_Web}>
                                우주펫에서 이웃시터가 되어<br />
                                우리동네 반려인들과 따뜻한 경험을 나눠보세요.
                            </span>
                        </div>
                        <img src={BackgroundImageWeb} style={styles.backgroundImage_Web} alt="배경" />
                    </div>
                </>
            ) : (
                <>
                    <div style={{ height: "90px" }} />
                    <div style={styles.screen_Mobile}>
                        <span style={styles.titleTxt_Mobile}>
                            우리 동네, 펫시터<br />
                            지금 시작해보세요
                        </span>
                        <div style={{ height: "0" }} />
                        <span style={styles.contentTxt_Mobile}>
                            우주펫에서 이웃시터가 되어<br />
                            우리동네 반려인들과 따뜻한 경험을 나눠보세요.
                        </span>
                        <img src={BackgroundImageMobile} style={styles.backgroundImage_Mobile} alt="배경" />
                    </div>
                </>
            )}

            <Dialog
                open={open}
                maxWidth={false}
                fullScreen={!isWeb}
                PaperProps={{
                    style: {
                        borderRadius: isWeb ? "40px" : "0px",
                        padding: isWeb ? "10px" : "0px",
                        width: isWeb ? "calc(100vw - 100px)" : "100vw",
                        height: isWeb ? "calc(100vh - 100px)" : "100vh",
                        maxWidth: isWeb ? "650px" : "100vw",
                        maxHeight: isWeb ? "850px" : "100vh",
                        overflowY: "scroll",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                    },
                }}
                className="custom-scroll"
            >
                <div style={{ width: "100%", height: "100%" }}>
                    <WriteBrowserComponent closeDialog={closeDialog} />
                </div>
            </Dialog>
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    screen_Web: { position: "relative", height: "93vh", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", paddingTop: responsivePaddingVertical(10, 130), boxSizing: "border-box" },
    titleTxt_Web: { fontSize: responsiveFont(22, 50), fontWeight: 700, letterSpacing: -0.3, lineHeight: "140%" },
    contentTxt_Web: { fontSize: responsiveFont(14, 30), fontWeight: 400, letterSpacing: -0.3, color: "#62686D", lineHeight: "140%" },
    backgroundImage_Web: { width: "100%", height: responsiveImageSize(388, 880), position: "absolute", bottom: 0, zIndex: -10 },
    paddingLeftDiv_Web: { width: "700px", paddingLeft: responsivePaddingHorizontal(24, 180), minWidth: "320px" },

    screen_Mobile: { position: "relative", minWidth: "320px", width: "100%", height: "90vh", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", paddingTop: responsivePaddingVertical(10, 130), boxSizing: "border-box" },
    titleTxt_Mobile: { fontSize: responsiveFont(22, 50), fontWeight: 700, letterSpacing: -0.3, paddingLeft: responsivePaddingHorizontal(24, 180), lineHeight: "140%" },
    contentTxt_Mobile: { fontSize: responsiveFont(14, 30), fontWeight: 400, letterSpacing: -0.3, color: "#62686D", paddingLeft: responsivePaddingHorizontal(24, 180), lineHeight: "140%" },
    backgroundImage_Mobile: { width: "100%", height: responsiveImageSize(388, 880), position: "absolute", bottom: 0, overflow: "hidden", marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, boxSizing: "border-box", zIndex: -10 }
});

export default Content01BrowserComponent;
